import { NgModule } from '@angular/core';
import { PlatformsRoutingModule } from '@app/platforms/platforms.routing';

@NgModule({
  declarations: [],
  imports: [PlatformsRoutingModule],
})
export class PlatformsModule {}
